import { faTrash } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Box, Grid, IconButton, styled, Typography, useTheme } from "@mui/material"
import { useTranslation } from "react-i18next"

const ViolationDrivingTypesRemove = ({ categories, removeViolationDrivingType }) => {
  const { t } = useTranslation()
  const theme = useTheme()

  const StyledBox = styled(Box)(({ index }) => ({
    borderBottom: `${categories.length - 1 !== index ? `1px solid ${theme.palette.grey[200]}` : "none"}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  }))

  const StyledGrid = styled(Grid)(() => ({
    border: `1px solid ${theme.palette.grey[200]}`,
    borderRadius: 6,
    display: "flex",
    flexDirection: "column",
    marginTop: theme.spacing(2)
  }))

  return categories.length > 0 ? (
    <StyledGrid container>
      {categories.map((item, key) => {
        return (
          <StyledBox p={1.5} index={key}>
            <Grid item xs={11}>
              <Typography variant="bodySmall" fontWeight={600}>
                {item.name}
              </Typography>
            </Grid>
            <IconButton
              size="small"
              onClick={() => {
                removeViolationDrivingType(item)
              }}
              color="error">
              <FontAwesomeIcon color={theme.palette.error.main} icon={faTrash} />
            </IconButton>
          </StyledBox>
        )
      })}
    </StyledGrid>
  ) : null
}
export default ViolationDrivingTypesRemove
